import { memo } from "react";
import { useContent } from "../../../../../contexts/contentContext/contentContext";
import Image from "../../../../Elements/Image/Image";
import Button from "../../../../Elements/Button/Button";
import { useInView } from "react-intersection-observer";
import { LinkToNewTab } from "../../../../Elements/Link/Link";

import styles from "./styles.module.scss";
import globalStyles from "../../styles.module.scss";

const InstantDeliverySection = memo(() => {
  const { getTextByKey, getHtmlByKey } = useContent();

  const [inViewRef, inView] = useInView({
    threshold: 0.3,
    rootMargin: "100px",
    triggerOnce: true,
  });

  return (
    <div
      className={`${globalStyles.sectionWrapper} ${styles.instantDeliveryWrapper}`}
      id="instant-delivery"
      ref={inViewRef}
    >
      <Image
        name="features/instant_delivery"
        ext="png"
        className={`${styles.instantDeliveryImage} ${
          inView ? globalStyles.slideInLeft : ""
        }`}
      />
      <div
        className={`${globalStyles.sectionElement} ${
          inView ? globalStyles.slideInRight : ""
        }`}
      >
        <h2>{getTextByKey("instant-delivery")}</h2>
        <p>{getHtmlByKey("instant-delivery-description-drag")}</p>
        <p>{getHtmlByKey("instant-delivery-description-wheel")}</p>
        {/*@ts-ignore*/}
        <LinkToNewTab page="user/contacts/contacts-list">
          <Button blank>{getTextByKey("learn-more")}</Button>
        </LinkToNewTab>
      </div>
    </div>
  );
});

export default InstantDeliverySection;
